export default __webpack_public_path__ + "static/media/Helm of Swiftstriking.174868ca.jpg";